import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
export const convertPixelPercentage = (val) => {
    if (typeof val === 'number')
        return `${val}px`;
    if (typeof val === 'string')
        return `${val}`;
    return '100%';
};
const SkeletonSquare = styled.span `
  width: ${(props) => convertPixelPercentage(props.width)};
  height: ${(props) => `${props.height}px`};
  display: block;
  border-radius: ${(props) => props.theme.SizeBorderRadiusSkeletonSmall};
  background: ${(props) => props.theme.ColorBackgroundSkeletonDefault};
  overflow: hidden;
  position: relative;
  mask-image: radial-gradient(circle, black 100%, rgba(0, 0, 0, 0) 100%);

  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: ${(props) => `linear-gradient(270.38deg, ${props.theme.ColorBackgroundSkeletonDefault} 0.31%, ${props.theme.ColorBackgroundSkeletonLight} 49.47%, ${props.theme.ColorBackgroundSkeletonDefault} 99.66%)`};
    animation: ${(props) => props.animation
    ? 'shine-loading-image-rec 1000ms infinite cubic-bezier(0, 0, 1, 1)'
    : '1s infinite cubic-bezier(0, 0, 1, 1)'};
    content: '';
  }

  @keyframes shine-loading-image-rec {
    100% {
      transform: translateX(100%);
    }
  }
`;
const SkeletonCircle = styled.span `
  width: ${(props) => convertPixelPercentage(props.width)};
  height: ${(props) => `${props.height}px`};
  display: block;
  border-radius: 50%;
  background: ${(props) => props.theme.ColorBackgroundSkeletonDefault};
  overflow: hidden;
  position: relative;
  mask-image: radial-gradient(circle, black 100%, rgba(0, 0, 0, 0) 100%);

  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: ${(props) => `linear-gradient(270.38deg, ${props.theme.ColorBackgroundSkeletonDefault} 0.31%, ${props.theme.ColorBackgroundSkeletonLight} 49.47%, ${props.theme.ColorBackgroundSkeletonDefault} 99.66%)`};
    animation: ${(props) => props.animation
    ? 'shine-loading-image-rec 1000ms infinite cubic-bezier(0, 0, 1, 1)'
    : '1s infinite cubic-bezier(0, 0, 1, 1)'};
    content: '';
  }

  @keyframes shine-loading-image-rec {
    100% {
      transform: translateX(100%);
    }
  }
`;
const SkeletonRectangle = styled.span `
  width: ${(props) => convertPixelPercentage(props.width)};
  height: ${(props) => `${props.height}px`};
  display: block;
  border-radius: ${(props) => props.theme.SizeBorderRadiusSkeletonMedium};
  background: ${(props) => props.theme.ColorBackgroundSkeletonDefault};
  overflow: hidden;
  position: relative;
  mask-image: radial-gradient(circle, black 100%, rgba(0, 0, 0, 0) 100%);

  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background: ${(props) => `linear-gradient(270.38deg, ${props.theme.ColorBackgroundSkeletonDefault} 0.31%, ${props.theme.ColorBackgroundSkeletonLight} 49.47%, ${props.theme.ColorBackgroundSkeletonDefault} 99.66%)`};
    animation: ${(props) => props.animation
    ? 'shine-loading-image-rec 1000ms infinite cubic-bezier(0, 0, 1, 1)'
    : '1s infinite cubic-bezier(0, 0, 1, 1)'};
    content: '';
  }

  @keyframes shine-loading-image-rec {
    100% {
      transform: translateX(100%);
    }
  }
`;
const Skeleton = (props) => {
    const { variant, className } = props;
    return (React.createElement(React.Fragment, null,
        variant === 'square' && React.createElement(SkeletonSquare, Object.assign({ className: className }, props)),
        variant === 'circle' && React.createElement(SkeletonCircle, Object.assign({ className: className }, props)),
        variant === 'rectangle' && React.createElement(SkeletonRectangle, Object.assign({ className: className }, props))));
};
Skeleton.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    animation: PropTypes.bool,
    variant: PropTypes.oneOf(['circle', 'square', 'rectangle']),
    className: PropTypes.string
};
Skeleton.defaultProps = {
    width: null,
    height: null,
    animation: true,
    variant: 'square',
    className: undefined
};
export { Skeleton as SkeletonRootComp };
export default withForwardedRef(Skeleton);
//# sourceMappingURL=Skeleton.js.map